module.exports = __webpack_public_path__ + "img/me.c2645e23.svg";